/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthSettingsRouteImport } from './routes/_auth.settings'
import { Route as AuthPipelineRouteImport } from './routes/_auth.pipeline'
import { Route as AuthMyDashboardRouteImport } from './routes/_auth.my-dashboard'
import { Route as AuthLeaderboardRouteImport } from './routes/_auth.leaderboard'
import { Route as AuthInboxRouteImport } from './routes/_auth.inbox'
import { Route as AuthDiallerRouteImport } from './routes/_auth.dialler'
import { Route as AuthDashboardRouteImport } from './routes/_auth.dashboard'
import { Route as AuthContactsRouteImport } from './routes/_auth.contacts'
import { Route as AuthCommandCenterRouteImport } from './routes/_auth.command-center'
import { Route as AuthCalendarRouteImport } from './routes/_auth.calendar'
import { Route as AuthContactsIdRouteImport } from './routes/_auth.contacts_.$id'
import { Route as AuthAdminNumbersRouteImport } from './routes/_auth.admin.numbers'
import { Route as AuthAdminCommissionRouteImport } from './routes/_auth.admin.commission'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPipelineRoute = AuthPipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMyDashboardRoute = AuthMyDashboardRouteImport.update({
  id: '/my-dashboard',
  path: '/my-dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLeaderboardRoute = AuthLeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInboxRoute = AuthInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDiallerRoute = AuthDiallerRouteImport.update({
  id: '/dialler',
  path: '/dialler',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContactsRoute = AuthContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCommandCenterRoute = AuthCommandCenterRouteImport.update({
  id: '/command-center',
  path: '/command-center',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCalendarRoute = AuthCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContactsIdRoute = AuthContactsIdRouteImport.update({
  id: '/contacts_/$id',
  path: '/contacts/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminNumbersRoute = AuthAdminNumbersRouteImport.update({
  id: '/admin/numbers',
  path: '/admin/numbers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminCommissionRoute = AuthAdminCommissionRouteImport.update({
  id: '/admin/commission',
  path: '/admin/commission',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/calendar': typeof AuthCalendarRoute
  '/command-center': typeof AuthCommandCenterRoute
  '/contacts': typeof AuthContactsRoute
  '/dashboard': typeof AuthDashboardRoute
  '/dialler': typeof AuthDiallerRoute
  '/inbox': typeof AuthInboxRoute
  '/leaderboard': typeof AuthLeaderboardRoute
  '/my-dashboard': typeof AuthMyDashboardRoute
  '/pipeline': typeof AuthPipelineRoute
  '/settings': typeof AuthSettingsRoute
  '/admin/commission': typeof AuthAdminCommissionRoute
  '/admin/numbers': typeof AuthAdminNumbersRoute
  '/contacts/$id': typeof AuthContactsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/calendar': typeof AuthCalendarRoute
  '/command-center': typeof AuthCommandCenterRoute
  '/contacts': typeof AuthContactsRoute
  '/dashboard': typeof AuthDashboardRoute
  '/dialler': typeof AuthDiallerRoute
  '/inbox': typeof AuthInboxRoute
  '/leaderboard': typeof AuthLeaderboardRoute
  '/my-dashboard': typeof AuthMyDashboardRoute
  '/pipeline': typeof AuthPipelineRoute
  '/settings': typeof AuthSettingsRoute
  '/admin/commission': typeof AuthAdminCommissionRoute
  '/admin/numbers': typeof AuthAdminNumbersRoute
  '/contacts/$id': typeof AuthContactsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/_auth/calendar': typeof AuthCalendarRoute
  '/_auth/command-center': typeof AuthCommandCenterRoute
  '/_auth/contacts': typeof AuthContactsRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/dialler': typeof AuthDiallerRoute
  '/_auth/inbox': typeof AuthInboxRoute
  '/_auth/leaderboard': typeof AuthLeaderboardRoute
  '/_auth/my-dashboard': typeof AuthMyDashboardRoute
  '/_auth/pipeline': typeof AuthPipelineRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/admin/commission': typeof AuthAdminCommissionRoute
  '/_auth/admin/numbers': typeof AuthAdminNumbersRoute
  '/_auth/contacts_/$id': typeof AuthContactsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/calendar'
    | '/command-center'
    | '/contacts'
    | '/dashboard'
    | '/dialler'
    | '/inbox'
    | '/leaderboard'
    | '/my-dashboard'
    | '/pipeline'
    | '/settings'
    | '/admin/commission'
    | '/admin/numbers'
    | '/contacts/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/calendar'
    | '/command-center'
    | '/contacts'
    | '/dashboard'
    | '/dialler'
    | '/inbox'
    | '/leaderboard'
    | '/my-dashboard'
    | '/pipeline'
    | '/settings'
    | '/admin/commission'
    | '/admin/numbers'
    | '/contacts/$id'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/_auth/calendar'
    | '/_auth/command-center'
    | '/_auth/contacts'
    | '/_auth/dashboard'
    | '/_auth/dialler'
    | '/_auth/inbox'
    | '/_auth/leaderboard'
    | '/_auth/my-dashboard'
    | '/_auth/pipeline'
    | '/_auth/settings'
    | '/_auth/admin/commission'
    | '/_auth/admin/numbers'
    | '/_auth/contacts_/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pipeline': {
      id: '/_auth/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof AuthPipelineRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/my-dashboard': {
      id: '/_auth/my-dashboard'
      path: '/my-dashboard'
      fullPath: '/my-dashboard'
      preLoaderRoute: typeof AuthMyDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/leaderboard': {
      id: '/_auth/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof AuthLeaderboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inbox': {
      id: '/_auth/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthInboxRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dialler': {
      id: '/_auth/dialler'
      path: '/dialler'
      fullPath: '/dialler'
      preLoaderRoute: typeof AuthDiallerRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contacts': {
      id: '/_auth/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthContactsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/command-center': {
      id: '/_auth/command-center'
      path: '/command-center'
      fullPath: '/command-center'
      preLoaderRoute: typeof AuthCommandCenterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/calendar': {
      id: '/_auth/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthCalendarRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contacts_/$id': {
      id: '/_auth/contacts_/$id'
      path: '/contacts/$id'
      fullPath: '/contacts/$id'
      preLoaderRoute: typeof AuthContactsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/numbers': {
      id: '/_auth/admin/numbers'
      path: '/admin/numbers'
      fullPath: '/admin/numbers'
      preLoaderRoute: typeof AuthAdminNumbersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/commission': {
      id: '/_auth/admin/commission'
      path: '/admin/commission'
      fullPath: '/admin/commission'
      preLoaderRoute: typeof AuthAdminCommissionRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthCalendarRoute: typeof AuthCalendarRoute
  AuthCommandCenterRoute: typeof AuthCommandCenterRoute
  AuthContactsRoute: typeof AuthContactsRoute
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthDiallerRoute: typeof AuthDiallerRoute
  AuthInboxRoute: typeof AuthInboxRoute
  AuthLeaderboardRoute: typeof AuthLeaderboardRoute
  AuthMyDashboardRoute: typeof AuthMyDashboardRoute
  AuthPipelineRoute: typeof AuthPipelineRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthAdminCommissionRoute: typeof AuthAdminCommissionRoute
  AuthAdminNumbersRoute: typeof AuthAdminNumbersRoute
  AuthContactsIdRoute: typeof AuthContactsIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCalendarRoute: AuthCalendarRoute,
  AuthCommandCenterRoute: AuthCommandCenterRoute,
  AuthContactsRoute: AuthContactsRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthDiallerRoute: AuthDiallerRoute,
  AuthInboxRoute: AuthInboxRoute,
  AuthLeaderboardRoute: AuthLeaderboardRoute,
  AuthMyDashboardRoute: AuthMyDashboardRoute,
  AuthPipelineRoute: AuthPipelineRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthAdminCommissionRoute: AuthAdminCommissionRoute,
  AuthAdminNumbersRoute: AuthAdminNumbersRoute,
  AuthContactsIdRoute: AuthContactsIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
